import { render, staticRenderFns } from "./Scene16.vue?vue&type=template&id=819bb4ca&scoped=true"
import script from "./Scene16.vue?vue&type=script&lang=js"
export * from "./Scene16.vue?vue&type=script&lang=js"
import style0 from "./Scene16.vue?vue&type=style&index=0&id=819bb4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819bb4ca",
  null
  
)

export default component.exports